export default "__VITE_ASSET__DEA8f4to__"